import {pick} from '@aboutyou/utils';

function containsMaliciousPattern(value: string): boolean {
  const maliciousPatterns = [
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, // Script tags
    /<\/?[^>]+(>|$)/g, // HTML tags
    /javascript:/gi, // JavaScript protocol
    /\bon\w+=/gi, // Event handlers (onclick, onload, etc.)
    /data:/gi, // Data URIs
  ];

  return maliciousPatterns.some(pattern => pattern.test(value));
}

export function parseCookies({
  cookieString = '',
  whitelistedCookies = [],
}: {
  cookieString?: string;
  whitelistedCookies: string[] | null;
}): Record<string, string> {
  const parsedCookies = parse(cookieString);

  return whitelistedCookies
    ? pick({inputObject: parsedCookies, keysToPick: whitelistedCookies})
    : parsedCookies;
}

/**
 * This functions is inspired by `parse` function from `cookie` library https://github.com/jshttp/cookie/blob/master/index.js#L49
 * This is also the function express/cookie-parser internally uses to parse the cookies
 */
function parse(cookieString: string) {
  const obj: Record<string, string> = {};
  const pairs = cookieString.split(pairSplitRegExp);

  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i]!;
    let eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    const key = pair.substr(0, eq_idx).trim();
    let val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if (val[0] === '"') {
      val = val.slice(1, -1);
    }

    const decodedVal = tryDecode(val);

    if (containsMaliciousPattern(decodedVal)) {
      continue;
    }

    // only assign once
    if (undefined === obj[key]) {
      obj[key] = decodedVal;
    }
  }

  return obj;
}

function tryDecode(str: string) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return str;
  }
}

const pairSplitRegExp = /; */;
